const DEFAULT_INTERVAL_MS = 1000;
const DEFAULT_MAX_DURATION_MS = 130000;

function normalizeAuthorizationStatus(response) {
    if (!response) {
        return "";
    }
    return String(response.status || "").toUpperCase();
}

function resolveApiBaseUrl(apiBaseUrl, currentHref) {
    const absoluteUrl = new URL(apiBaseUrl, currentHref);
    return absoluteUrl.toString().replace(/\/$/, "");
}

function buildAuthorizationBridgeUrl(apiBaseUrl, sessionId, currentHref) {
    const absoluteApiBaseUrl = resolveApiBaseUrl(apiBaseUrl, currentHref);
    const bridgeUrl = new URL(absoluteApiBaseUrl + "/valorantTracker/authorization/bridge.js");
    bridgeUrl.searchParams.set("sessionId", sessionId);
    bridgeUrl.searchParams.set("apiBaseUrl", absoluteApiBaseUrl);
    return bridgeUrl.toString();
}

async function pollAuthorizationSession(options) {
    const request = options.request;
    const wait = options.wait;
    const isActive = options.isActive || (() => true);
    const intervalMs = options.intervalMs || DEFAULT_INTERVAL_MS;
    const maxDurationMs = options.maxDurationMs || DEFAULT_MAX_DURATION_MS;
    const waitingMaxDurationMs = options.waitingMaxDurationMs || 0;
    const now = options.now || Date.now;
    const startedAt = now();
    let attempts = 0;
    let lastResponse = null;
    let lastError = null;
    let runningObserved = false;

    while (now() - startedAt < maxDurationMs) {
        if (!isActive()) {
            return { status: "cancelled", attempts };
        }

        attempts += 1;
        try {
            lastResponse = await request(attempts);
            lastError = null;
        } catch (error) {
            lastResponse = null;
            lastError = error;
        }

        if (!isActive()) {
            return { status: "cancelled", attempts };
        }
        if (lastResponse && lastResponse.error) {
            return { status: "expired", attempts, response: lastResponse };
        }
        const status = normalizeAuthorizationStatus(lastResponse);
        if (status === "RUNNING") {
            runningObserved = true;
        }
        if (status === "SUCCESS") {
            return { status: "success", attempts, response: lastResponse };
        }
        if (status === "NOT_FOUND") {
            return { status: "not_found", attempts, response: lastResponse };
        }
        if (status === "CANCELLED") {
            return { status: "server_cancelled", attempts, response: lastResponse };
        }
        if (status === "TIMEOUT" || status === "FAILED") {
            return { status: status.toLowerCase(), attempts, response: lastResponse };
        }
        if (status === "WAITING" && options.stopOnWaiting) {
            return { status: "waiting", attempts, response: lastResponse };
        }
        if (status === "WAITING"
            && !runningObserved
            && waitingMaxDurationMs > 0
            && now() - startedAt >= waitingMaxDurationMs) {
            return { status: "waiting_timeout", attempts, response: lastResponse };
        }

        const remainingMs = maxDurationMs - (now() - startedAt);
        const shouldContinue = await wait(Math.min(intervalMs, remainingMs), attempts);
        if (shouldContinue === false || !isActive()) {
            return { status: "cancelled", attempts };
        }
    }

    return { status: "timeout", attempts, response: lastResponse, error: lastError };
}

module.exports = {
    DEFAULT_INTERVAL_MS,
    DEFAULT_MAX_DURATION_MS,
    buildAuthorizationBridgeUrl,
    normalizeAuthorizationStatus,
    pollAuthorizationSession,
    resolveApiBaseUrl,
};
